exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box[data-v-31da8e5c]{width:200px;height:34px;line-height:34px;border:1px solid #cccccc;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;background:#ffffff}.content-box .title-txt[data-v-31da8e5c]{font-size:14px;color:#999999}.content-box .input-box[data-v-31da8e5c]{width:120px;border-left:1px solid #cccccc}.content-box[data-v-31da8e5c] .el-input__inner{height:30px;line-height:30px;border:none;color:#999999;padding:0 6px}\n", ""]);

// exports
